import { ApiResource } from "../ApiResource";
import { User } from "./User";
// import { Promise } from "es6-promise";
export class ApiUserResource extends ApiResource {
    constructor(client, version = "1.0") {
        super(client, ApiUserResource.USER_ROUTE, version);
    }
    getMe() {
        return this.getByIdGeneric(User, "me");
    }
    getUserById(userId) {
        return this.getGeneric(User, {
            urlPostfix: "find/" + userId,
        });
    }
    getUserOrganizations(clientId, username, password) {
        return this.create({
            clientId,
            username,
            password,
        }, {
            urlPostfix: "find/organizations",
        });
    }
}
ApiUserResource.USER_ROUTE = "/security/user";
